import React from 'react'
import "../../ErrorHandling/Page_Internal_Server_Error/Page_500.css"
import { useHistory } from "react-router-dom"

export const Page_500 = () => {
    const history = useHistory()
    return (
        <div className="container1_500">
            <div className="container500"></div>
                <div className="content500_1">
                    {/* <div className="container500_inner">
                        <span className="container_inside500">I</span>
                        <span className="container_inside500">N</span>
                        <span className="container_inside500">T</span>
                        <span className="container_inside500">E</span>
                        <span className="container_inside500">R</span>
                        <span className="container_inside500">N</span>
                        <span className="container_inside500">A</span>
                        <span className="container_inside500">L</span>
                    </div>

                    <div className="container500_inner">
                        <span className="container_inside500"> </span>
                        <span className="container_inside500">S</span>
                        <span className="container_inside500">E</span>
                        <span className="container_inside500">R</span>
                        <span className="container_inside500">V</span>
                        <span className="container_inside500">E</span>
                        <span className="container_inside500">R</span>
                        <span className="container_inside500"> </span>
                    </div>

                    <div className="container500_inner">
                        <span className="container_inside500">E</span>
                        <span className="container_inside500">R</span>
                        <span className="container_inside500">R</span>
                        <span className="container_inside500">O</span>
                        <span className="container_inside500">R</span>
                    </div>

                </div>
                <div className="content500_2">
                    <div className="container500_inner">
                        <span className="container_inside500_1">5</span>
                        <span className="container_inside500_1">0</span>
                        <span className="container_inside500_1">0</span>
                    </div>
                </div> */}

            </div>
            <button className="btn_home_500" onClick={() => {
                // localStorage.removeItem("navigate_404")
                history.goBack()
            }}>Go to Home</button>
        </div>
    )
}
